var _style, _g, _g2, _g3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#85355F;}\r\n\t.st2{enable-background:new    ;}\r\n\t.st3{fill:#F39400;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 130,
    height: 130
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,75.6c-0.7,1.7-1.6,3.1-2.9,4.4c-1.2,1.2-2.8,2.1-4.5,2.8c-1.7,0.7-3.7,1-5.8,1c-1.6,0-3.1-0.2-4.6-0.5 s-3.1-0.9-4.9-1.6V45.9l4.8-1.5v14.7c1.1-0.6,2.1-1.1,3.1-1.3c1.1-0.3,2.4-0.4,4-0.4c1.7,0,3.3,0.3,4.7,0.9 c1.4,0.6,2.6,1.5,3.7,2.6c1.1,1.1,1.9,2.4,2.4,3.9c0.6,1.5,0.8,3.2,0.8,5.1C66.2,71.9,65.8,73.8,65.1,75.6z M60.7,66.6 c-0.3-1-0.8-1.9-1.5-2.6c-0.6-0.7-1.3-1.3-2.2-1.7c-0.8-0.4-1.8-0.6-2.8-0.6c-1.2,0-2.4,0.2-3.4,0.6c-1,0.3-2.2,1.1-3.4,2.1v14.3 c0.8,0.3,1.7,0.5,2.5,0.7c0.8,0.2,1.5,0.2,2.3,0.2c1.3,0,2.5-0.2,3.7-0.7c1.1-0.4,2.1-1.1,2.9-2c0.8-0.8,1.5-1.9,1.9-3 c0.4-1.2,0.7-2.4,0.7-3.8C61.2,68.7,61,67.6,60.7,66.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.9,71c-0.1,1.2,0,2.4,0.5,3.4c0.4,1,1,2,1.8,2.7c0.8,0.8,1.7,1.4,2.7,1.8c1.1,0.4,2.2,0.7,3.4,0.7 c1.4,0,2.6-0.3,3.8-0.8c1.2-0.5,2.4-1.2,3.6-2.2l2.2,3.7c-1.5,1.1-3,2-4.7,2.6c-1.7,0.6-3.4,0.9-5.3,0.9c-1.9,0-3.7-0.3-5.3-1 c-1.6-0.7-2.9-1.6-4.1-2.8c-1.1-1.2-2-2.6-2.6-4.3c-0.6-1.7-0.9-3.5-0.9-5.4c0-1.9,0.3-3.6,0.9-5.2c0.6-1.6,1.4-2.9,2.4-4.1 c1-1.2,2.3-2,3.8-2.7c1.5-0.6,3.1-0.9,4.9-0.9c1.3,0,2.7,0.3,4,0.8c1.4,0.5,2.6,1.3,3.7,2.4c1.1,1.1,2,2.5,2.6,4.2 c0.7,1.7,1,3.8,1,6.2H73.9z M84.8,63.1c-1-1-2.3-1.5-3.9-1.5c-1.6,0-3,0.5-4.1,1.5c-1.1,1-1.9,2.3-2.3,4h12.4 C86.5,65.5,85.8,64.1,84.8,63.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.6,80.9c0,0-14.3-24.8,3.4-41.9c0,0,17.5-17.4,41-3.8c0,0-21.9-10.7-40.3,11.7C38.7,47,26.5,61,34.6,80.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.1,95.1c0,0,24.7,16.4,44.5-6c0,0,12.1-13.5,3.1-35.4c0,0,6.5,19.6-9.6,34.7C87,88.4,72.7,104.4,49.1,95.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.54b236d7744dbe8fedcee71b73be9b95.svg";
export { ForwardRef as ReactComponent };